import { supabase } from "@/integrations/supabase/client";
import { writeExpectingRows } from "@/lib/supabase-write";

/**
 * Soft delete de um projeto do controle. Avaliação sem resposta de projeto
 * excluído é lixo: some da listagem e deixa de poder receber email. Quem já
 * respondeu (rating) fica intacto.
 */
export async function softDeleteControleProjeto(projectId: string): Promise<void> {
  const deletedAt = new Date().toISOString();

  await writeExpectingRows(
    supabase
      .from("controle_projetos")
      .update({ deleted_at: deletedAt })
      .eq("id", projectId),
    "excluir projeto",
  );

  const { error: evaluationsError } = await supabase
    .from("job_evaluations")
    .update({ deleted_at: deletedAt })
    .eq("controle_projeto_id", projectId)
    .is("deleted_at", null)
    .is("rating", null);

  if (evaluationsError) throw evaluationsError;
}
